import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { NavigationEnd, Router, Scroll } from '@angular/router';
import { Observable, filter, map, merge, of } from 'rxjs';

@Component({
  selector: 'lib-skip-to-content',
  templateUrl: './skip-to-content.component.html',
  styleUrls: ['./skip-to-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SkipToContentComponent implements OnInit {
  @Input() mainId: string;

  currentUrl$: Observable<string>;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.currentUrl$ = merge(
      of(location.pathname),
      this.router.events.pipe(
        filter(
          (event: Scroll) =>
            event.routerEvent && event.routerEvent instanceof NavigationEnd,
        ),
        map((event) => {
          const navigationEnd: NavigationEnd =
            event.routerEvent as NavigationEnd;
          return navigationEnd.urlAfterRedirects;
        }),
      ),
    );
  }
}
